// react
import React, { useEffect } from "react";
// link
import { AdminRoutes } from "../../features/routes/adminRoutes.tsx";
// base
import Admin from "./admin.tsx";
// @ts-ignore
import Cookies from "js-cookie";
// navigate
import { useNavigate } from "react-router-dom";

const AdminBase = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!Cookies.get('admin_token')) {
            navigate('/404');
        }
    }, [navigate]);
    if (Cookies.get('admin_token')) {
        return (
            <>
                <Admin routes={AdminRoutes.admin} />
            </>
        )
    }
}

export default AdminBase;